import h5Recorder from './h5Recorder'
const msgSender = makeUniMsgSender()
const MessageHandlers = {
	startAsr: function(json) {
		h5Recorder.recStart__asrStart(json.token, json.lang)
	},
	stopAsr: function(json) {
		h5Recorder.asrCancel()
	},
	requestPermissions: function(json) {
		h5Recorder.recReq({}, 'permissions')
	}
}

// 接收消息
export function postMessage(jsonable) {
	console.log(
		'========= postMessagge ========= (',
		JSON.stringify(jsonable),
		')'
	)
	let handler = MessageHandlers[jsonable.action]
	try {
		handler(jsonable)
	} catch (ex) {
		console.error(
			'========= postMessagge ========= Failed todo action:',
			jsonable.action
		)
		console.log(ex)
	}
}

// 消息发射器
export function makeUniMsgSender() {
	// 获取接收端的 WebView
	const rxWebView = window
	if (rxWebView) {
		return {
			/**
			 * 接收端 WebView
			 */
			rxWebView: rxWebView,
			/**
			 * 发送数据
			 * @param {string} eventName 事件名称
			 * @param {object} payload 事件数据
			 */
			sendMessage: function(eventName, payload) {
				if (typeof window.onUniMessage === 'function') {
					window.onUniMessage(eventName, JSON.stringify(payload))
				} else {
					console.error('window.onUniMessage is not a function')
				}
			}
		}
	}
	return null
}


// WEBPACK FOOTER //
// ./utils/h5UniMsgHandlers.js